import styled from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  margin-top: 25px; 
  width: 70%; 
`;

export default Wrapper(template)
